import { useGetFileQuery } from '@/features/files';

import { ServiceDetails } from '../types';

export function useServiceDocuments(service: ServiceDetails) {
  const documents = service.documents;
  return documents.map((document) => useGetFileQuery({ id: document }).data);
}
